import { useRef, useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Thumbs } from 'swiper/modules'
import LocationIcon from '../../assets/icons/LocationIcon'
import ClockIcon from '../../assets/icons/ClockIcon'
import BusIcon from '../../assets/icons/BusIcon'
import { useOnClickOutside } from 'usehooks-ts'
import { useSearchParams } from 'react-router-dom'
import ImageFader1 from '../../assets/headquarters/fader/fader-1.webp'
import ImageFader2 from '../../assets/headquarters/fader/fader-2.webp'
import ImageFader3 from '../../assets/headquarters/fader/fader-3.webp'
import ImageFader4 from '../../assets/headquarters/fader/fader-4.webp'
import ImageFader5 from '../../assets/headquarters/fader/fader-5.webp'
import ImageFader6 from '../../assets/headquarters/fader/fader-6.webp'
import ImageFader7 from '../../assets/headquarters/fader/fader-7.webp'
import ImageFader8 from '../../assets/headquarters/fader/fader-8.webp'
import ImageFader9 from '../../assets/headquarters/fader/fader-9.webp'
import ImageFader10 from '../../assets/headquarters/fader/fader-10.webp'
import ImageWast1 from '../../assets/headquarters/wast/wast-1.webp'
import ImageWast2 from '../../assets/headquarters/wast/wast-2.webp'
import ImageWast3 from '../../assets/headquarters/wast/wast-3.webp'
import ImageWast4 from '../../assets/headquarters/wast/wast-4.webp'
import ImageWast5 from '../../assets/headquarters/wast/wast-5.webp'
import imageCarousel1 from '../../assets/headquarters/carousel/carousel-1.webp'
import imageCarousel2 from '../../assets/headquarters/carousel/carousel-2.webp'
import imageCarousel3 from '../../assets/headquarters/carousel/carousel-3.webp'
import imageCarousel4 from '../../assets/headquarters/carousel/carousel-4.webp'
import imageCarousel5 from '../../assets/headquarters/carousel/carousel-5.webp'

const OPTIONS = ['fader', 'wast']
const HQ = {
  fader: 'Sede Fader - Fernando Fader 3971',
  wast: 'Sede Wast - Hugo Wast 4557'
}
const MAPS = {
  fader: 'https://www.google.com/maps/d/u/0/embed?mid=1PyGhgOe8qP5nyG7iND21CMavpL6AQ1c&ehbc=2E312F&ll=-31.374279624346947%2C-64.23339644077738&z=17',
  wast: 'https://www.google.com/maps/d/u/0/embed?mid=1PyGhgOe8qP5nyG7iND21CMavpL6AQ1c&ehbc=2E312F&ll=-31.36593157424009%2C-64.23965181954144&z=17'
}
const MAP_ITEMS = [
  {
    title: '300 metros de la zona bancaria',
    description: '300 mts. de bancos y ATMs',
    icon: <LocationIcon width={24} height={24}/>
  }, {
    title: '15\' del centro',
    description: '15\' del centro de la ciudad',
    icon: <ClockIcon width={24} height={24}/>
  }, {
    title: 'Cercanía a bares y restaurantes',
    description: '200 mts. de cafeterías, restaurantes y bares',
    icon: <LocationIcon width={24} height={24}/>
  }, {
    title: 'Colectivos desde Zona Centro y Nueva Córdoba',
    description: '13, 18, 19, 80, 83, B1',
    icon: <BusIcon width={24} height={24}/>
  }, {
    title: '12\' del aeropuerto',
    description: '12\' del Aeropuerto Internacional de Córdoba',
    icon: <ClockIcon width={24} height={24}/>
  }
]

const IMAGES_FADER = [
  ImageFader1,
  ImageFader2,
  ImageFader3,
  ImageFader4,
  ImageFader5,
  ImageFader6,
  ImageFader7,
  ImageFader8,
  ImageFader9,
  ImageFader10
]

const IMAGES_WAST = [
  ImageWast1,
  ImageWast2,
  ImageWast3,
  ImageWast4,
  ImageWast5
]

const IMAGES_CAROUSEL = [
  imageCarousel1,
  imageCarousel2,
  imageCarousel3,
  imageCarousel4,
  imageCarousel5
]

const IMAGES = {
  fader: IMAGES_FADER,
  wast: IMAGES_WAST
}

const HeadQuarters = () => {
  const selectorRef = useRef(null)
  const [ showOptions, setShowOptions ] = useState(false)
  const [ selectedOption, setSelectedOption ] = useState(OPTIONS[0])
  const [ thumbsSwiper, setThumbsSwiper ] = useState(null)
  const searchParams = useSearchParams()[0]

  useOnClickOutside(selectorRef, () => setShowOptions(false))

  useEffect(() => {
    if (searchParams.has('fader')) {
      setSelectedOption('fader')
    } else if (searchParams.has('wast')) {
      setSelectedOption('wast')
    }
  }, [searchParams])

  return (
    <>
      <Helmet>
        <title>Vida Cowork: Sedes</title>
      </Helmet>

      <main className="HeadQuarters">
        <section className="HeadQuarters__Items-Container container-fluid">
          <div className="HeadQuarters__Items container-custom">
            <div className="HeadQuarters__Text-Container">
              <h1 className='title'>SEDES</h1>

              <div className="d-flex flex-column gap-4">
                <span className='text-2'>
                  Seleccioná la sede que más te guste
                </span>

                <div
                  ref={selectorRef}
                  className="HeadQuarters__Selector-Container"
                >
                  <button
                    className="HeadQuarters__Selector"
                    onClick={() => setShowOptions(true)}
                  >
                    <span>{ HQ[selectedOption] }</span>

                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.52233 9.00087C7.6516 9.00031 7.77968 9.02338 7.89907 9.06871C8.01846 9.11405 8.12675 9.18074 8.21758 9.26487L12.153 12.8648L16.0883 9.26487C16.2789 9.18069 16.4941 9.15496 16.7019 9.19151C16.9097 9.22805 17.0991 9.32492 17.242 9.46774C17.3848 9.61055 17.4736 9.7917 17.495 9.98429C17.5164 10.1769 17.4693 10.3707 17.3608 10.5369L12.7695 14.7368C12.585 14.9053 12.335 15 12.0743 15C11.8135 15 11.5635 14.9053 11.379 14.7368L6.78773 10.5369C6.60349 10.3681 6.5 10.1394 6.5 9.90086C6.5 9.66236 6.60349 9.43362 6.78773 9.26487C6.88314 9.17626 6.99783 9.10697 7.12438 9.06149C7.25092 9.01601 7.3865 8.99536 7.52233 9.00087Z" fill="#656565"/>
                    </svg>
                  </button>

                  {showOptions && (
                    <div className="HeadQuarters__Options">
                      {OPTIONS.map((option, index) => (
                        <button
                          key={`HeadQuarters__Option-${index}`}
                          className={selectedOption === option ? 'HeadQuarters__Option--Active' : 'HeadQuarters__Option'}
                          onClick={() => {
                            setShowOptions(false)
                            setSelectedOption(option)
                          }}
                        >
                          {HQ[option]}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="HeadQuarters__Info">
              <div className="HeadQuarters__Gallery">
                <Swiper
                  onSwiper={setThumbsSwiper}
                  slidesPerView={4}
                  spaceBetween={16}
                  watchSlidesProgress={true}
                  modules={[Navigation, Thumbs]}
                  breakpoints={{
                    768: {
                      slidesPerView: 5,
                      spaceBetween: 24,
                      direction: 'vertical'
                    }
                  }}
                  className='HeadQuarters__Gallery-List'
                >
                  {IMAGES[selectedOption].map((image, index) => (
                    <SwiperSlide key={`HeadQuarters__Gallery-List-Image-${index}`}>
                      <img src={image} />
                    </SwiperSlide>
                  ))}
                </Swiper>

                <Swiper
                  style={{
                    '--swiper-navigation-color': '#fff',
                    '--swiper-pagination-color': '#fff',
                  }}
                  spaceBetween={24}
                  thumbs={{ swiper: thumbsSwiper }}
                  modules={[Navigation, Thumbs]}
                  className="HeadQuarters__Gallery-Main"
                >
                  {IMAGES[selectedOption].map((image, index) => (
                    <SwiperSlide key={`HeadQuarters__Gallery-Main-Image-${index}`}>
                      <img src={image} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              <div className="HeadQuarters__Map-Container">
                <iframe
                  className="HeadQuarters__Map"
                  src={MAPS[selectedOption]}
                  loading="lazy"
                  title='Ubicaciones de Vida Cowork'
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>

                <div className="HeadQuarters__Map-Items">
                  {MAP_ITEMS.map((item, index) => (
                    <div
                      key={`HeadQuarters__Map-Item-${index}`}
                      className="HeadQuarters__Map-Item"
                    >
                      { item.icon }
                      <div className="d-flex flex-column gap-1 text-6">
                        <span className="fw-bold">{item.title}</span>
                        <span className='text-gray-dark'>{item.description}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="HeadQuarters__Images-Container container-fluid">
          <div className="HeadQuarters__Images container-custom">
            <Swiper
              className='HeadQuarters__Swiper'
              modules={[ Autoplay ]}
              slidesPerView={3}
              spaceBetween={16}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false
              }}
              allowTouchMove={false}
              loop
              speed={1500}
              breakpoints={{
                992: {
                  slidesPerView: 4
                },
                1400: {
                  slidesPerView: 5,
                  spaceBetween: 24
                }
              }}
            >
              {IMAGES_CAROUSEL.map((image, index) => (
                <SwiperSlide key={`HeadQuarters-Swiper-Image-${index}`}>
                  <img
                    className='HeadQuarters__Swiper-Image'
                    src={image}
                    alt='Vida Cowork'
                    title='Vida Cowork'
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      </main>
    </>
  )
}

export default HeadQuarters